"use strict";

function supportsConsentCategories() {
  if (typeof window === 'undefined') return false;
  return !!window.consentManager?.getTrackingPreferences;
}
module.exports = {
  supportsConsentCategories
};